import React from "react";
import { Button, Thumbnail, DropZone, EmptyState, Box, BlockStack } from "@shopify/polaris";
import { Link } from "react-router-dom";

function UploadBrandLogo({
  brandFile,
  setBrandFile,
  brandLogo,
  handleRemoveImage,
  setIsDirty,
}: {
  readonly brandFile: File | null;
  readonly setBrandFile: (file: File) => void;
  readonly brandLogo: string | null;
  readonly setIsDirty: (dirty: boolean) => void;
  readonly handleRemoveImage: () => void;
}): React.ReactElement {
  const handleDropZoneDrop = (files: File[]): void => {
    setBrandFile(files[0]);
    setIsDirty(true);
  };

  const url: string = brandFile ? URL.createObjectURL(brandFile) : brandLogo ?? "";

  const fileUpload = (
    <Box padding="400">
      <BlockStack gap="200" inlineAlign="center">
        <Thumbnail alt="" size="medium" source={url} />
        <Button>Change Image</Button>
        <Link onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleRemoveImage();
        }} to="#">Remove image</Link>
      </BlockStack>
    </Box>
  );

  return (
    <DropZone
      accept="image/jpeg,image/png"
      allowMultiple={false}
      label="Company logo"
      onDrop={handleDropZoneDrop}
    >
      {url === "" ? (
        <Box padding="400">
          <BlockStack gap="200" inlineAlign="center">
            <EmptyState
              action={{
                content: "Upload image",
              }}
              footerContent="or drag and drop an image here"
              image=""
            />
          </BlockStack>
        </Box>
      ) : fileUpload}
    </DropZone>
  );
}

export default UploadBrandLogo;
